import { Flex } from '@chakra-ui/react';
import { Check as CheckIcon } from '@mui/icons-material';

interface VoucherCheckmarkProps {
  size?: 'sm' | 'md';
}

export const VoucherCheckmark = ({ size = 'sm' }: VoucherCheckmarkProps) => {
  const dimensions = size === 'sm' ? '16px' : '20px';
  const iconSize = size === 'sm' ? '10px' : '14px';

  return (
    <Flex
      w={dimensions}
      h={dimensions}
      borderRadius="4px"
      bg="green.500"
      alignItems="center"
      justifyContent="center"
    >
      <CheckIcon sx={{ color: 'white', fontSize: iconSize }} />
    </Flex>
  );
};
